import { req , reqJson} from './axiosFun';

/**
 * 订单管理-交易订单
 **/
// 支付订单 - 查询支付订单列表
export const orderList = (params) => { return reqJson("post", "/api/orders/queryByAdminPage", params) };
// 支付订单 - 根据id获取详情
export const getById = (orderId) => { return reqJson("get","/api/orders/orders/id" + orderId ) };



// WEBPACK FOOTER //
// ./src/api/orderMG.js